export default {"id":"7f3012f5","attrs":{"viewBox":"0 0 512 512","width":"512","height":"512"}}